<template>
  <el-dialog
    :close-on-click-modal="false"
    title="取消订单"
    :visible.sync="visible"
    width="500px"
    class="exchangeDialog"
    :before-close="handleClose"
  >
    <div>
      <el-form :model="form" ref="form" label-width="90px">
        <el-form-item label="订单编号：">
          {{ form.appNo }}
        </el-form-item>
        <el-form-item
          label="取消原因："
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
          prop="auditOpinion"
        >
          <el-input
            v-model="form.auditOpinion"
            class="input"
            size="small"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small"> 确定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { forceCancel } from "@/api/order/all"
import { mapGetters } from "vuex"

export default {
  name: "CancelOrder",
  data() {
    return {
      form: { appId: "", appNo: "", auditOpinion: "" },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    visible() {
      this.$nextTick(() => {
        this.form.auditOpinion = ""
        this.form.appId = this.orderData.appId
        this.form.appNo = this.orderData.appNo
      })
    },
  },
  methods: {
    sure() {
      let form = this._.clone(this.form)
      form.appNo = undefined
      if (!form.auditOpinion) {
        this.msgError("请输入取消原因")
        return
      }
      forceCancel(form).then((res) => {
        if (res.code !== 200) {
          this.$message.error("取消失败")
        } else {
          this.$message.success("取消成功")
          this.$emit("onOk")
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.exchangeDialog {
  font-size: 12px;
}
.tip {
  margin-top: 10px;
  font-size: 12px;
}
.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}
</style>
